/**
 * 切记要在gis下的index.ts文件中添加示例组件
 */

import ClassCollection from './index';

export default class Modules {
    private modules: any = {};
    private options: any;
    /**
     *
     * @param opts
     * @param opts.map
     * @param opts.basicComponents
     * @param opts.config
     */
    constructor(opts: any) {
        this.options = opts;
        this.modules.options = this.options;
    }
    /**
     * 创建组件
     * @param opts {Object}
     */
    public createComponents(opts: any = {}) {
        const ClassCol: any = ClassCollection;
        // 示例
        const demoComponent = new ClassCol.demoComponent({
            map: this.options.map,
            symbolConfig: this.options.symbolConfig,
            simpleRenderMgr: this.options.basicComponents.simpleRenderMgr,
            PointGeometryBuilder: this.options.basicComponents.PointGeometryBuilder,
            popupManager: this.options.basicComponents.popupManager,
            featureLocate: this.options.basicComponents.featureLocate,
            featureHighlight: this.options.basicComponents.featureHighlight,
            serviceConfig: this.options.serviceConfig,
        });
        /**
         * 这里向modules里面添加的component名称是前端调用的componentName
         */
        this.modules.demoComponent = demoComponent;
    }

    public initComponents(opts: any = {}) {
        this.createComponents(opts);
        return this.modules;
    }
}
